import * as procDef from './procDef'
import * as procInst from './procInst'
import * as procModel from './procModel'
import * as task from './task'
import * as hiProcInst from './hiProcInst'
import * as selectUser from './selectUser'
import * as entrustment from './entrustment'
import * as dimission from './dimission'

/**
 * 获取租户拥有的模板
 */
export default {
  procDef,
  procInst,
  procModel,
  hiProcInst,
  task,
  selectUser,
  dimission,
  entrustment
};
